/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type SourceType = (typeof SourceType)[keyof typeof SourceType];

export const SourceType = {
  ADMIN: "ADMIN",
  STRIPE: "STRIPE",
  SYSTEM: "SYSTEM",
  ONE_TIME_PURCHASE: "ONE_TIME_PURCHASE",
  PARTNER_AFFILIATION: "PARTNER_AFFILIATION",
  ACCOUNT_MERGE: "ACCOUNT_MERGE",
  CLI: "CLI",
} as const;
